import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../services/local-storage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-adv-header-before-login',
  templateUrl: './adv-header-before-login.component.html',
})
export class AdvHeaderBeforeLoginComponent implements OnInit {

  constructor(private localstorage:LocalStorage,private router:Router) { }

  ngOnInit() {
  }
     redirectpage() {
     var token=this.localstorage.getStorage('token');
     if(token) {
    this.router.navigate(['advertiser/campaignlist']); 
     }
     else {
       this.router.navigate(['']); 
     } 
  }

}



// WEBPACK FOOTER //
// ./src/app/common/adv-header-before-login.component.ts